<template>
  <div class="wrapper">
    <div class="head">
      <img :src="icon" />
      <span>{{name}}</span>
      <span class="home">{{title}}</span>
    </div>
    <div class="content">
      <div class="bg-stripe" />
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in list" :key="index">
          <div class="block">
            <div class="block-text" >
              <div class="text-icon" v-if="index == 0">
                <img :src="icon" />
                <span>{{name}}</span>
              </div>
              <div class="text-box" v-html="item.text" />
            </div>
            <div class="block-img"><img :src="item.img" /></div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="footer">
      <p><a href="https://beian.miit.gov.cn/" target="_blank">{{copyright}}</a></p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Swipe, SwipeItem } from 'vant'
Vue.use(Swipe).use(SwipeItem)
export default {
  data() {
    return {
      name: '首页',
      icon: '',
      title: '首页',
      list: [],
    }
  },
  computed:{
    sdata() {
      return this.$store.state.data;
    }
  },
  created() {
    let data = this.sdata
    this.list = data.list
    this.name = data.name
    this.icon = data.icon
    this.copyright = data.copyright
    document.title = this.name
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  background: #fff;
  // 顶部导航栏
  .head {
    width: calc(100% - 1.5rem);
    padding: 0 .75rem;
    height: .45rem;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .11rem;
    color: #333;
    box-shadow: .01rem .02rem .1rem 0 rgba(49,41,55,0.3);
    img {
      width: .3rem;
      height: .3rem;
      margin-right: .14rem;
    }
    .home {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background: #4D6FFF;
      width: .9rem;
      height: .45rem;
      margin-left: .3rem;
    }
  }
  .content {
    position: relative;
    display: flex;
    width: 100%;
    height: calc(100vh - .95rem);
    align-items: center;
    background-image: linear-gradient(143deg, #58E0FF 0%, #4039DE 100%);
    .bg-stripe {
      position: absolute;
      right: 0;
      top: 0;
      width: 30%;
      height: 80%;
      background: url('~@/assets/images/s1.png') no-repeat !important;
      background-size: 100% 100% !important;
    }

    .my-swipe {
      width: 100%;
      height: 100%;
    }
    /deep/ .van-swipe__indicators {
      left:70%;
      bottom:.3rem;
    }
    /deep/ .van-swipe__indicator {
      margin-left: .1rem;
    }

    .block {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: calc(100% - 1.5rem);
      padding: 0 .75rem;
      height: 100%;

      .block-img {
        background: #FFFFFF;
        background: #FFFFFF;
        box-shadow: .01rem .01rem 0.3rem 0 rgba(0,0,0,0.50);
        border-radius: .15rem;
        width: 1.9rem;
        height: 3.4rem;
        padding: .08rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: .11rem;
          border: .005rem solid #ddd;
        }
      }
      .block-text {
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        max-width: 4rem;
        .text-icon{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: .45rem;
          color: #fff;
          margin-bottom: .38rem;

          img {
            margin-right: .23rem;
            width: .85rem;
            height: .85rem;
            border-radius: .18rem;
            border: .03rem solid rgba(255,255,255,0.5);
          }

        }
        .text-box {
          font-size: .15rem;
          color: #fff;
          line-height: .26rem;
          margin-right: .3rem
        }
      }
    }
  }

  // 底部备案
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: .5rem;
    background: #333;
    font-size: .1rem;
    color: #fff;
    a, a:visited {
      color: #fff;
    }
  }
}
</style>
